<template>
    <div class="container-fluid  pt-4">

        <div class="row">
            <div class="col-md-6 col-sm-12">
                <h3>Inventory Activity</h3>
            </div>
            <div class="col-md-6 col-sm-12">
                <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker pb-2">
                            <template #input="picker" style="width: 100% !important;">
                                                        <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                        <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
                            </template>
                                            </date-range-picker>
            </div>
        </div>
        <div style="margin-bottom: 5em;" v-if="hasLoaded">

            <div v-if="items.length > 0">
                <hr />
                <div v-if="allSoldQty >0" class="row text-center">
            <div class="col-md-4 col-sm-4 border-right border-dark">
                <h5>{{ allSoldQty }}</h5>
                <p>Sum of Sold Items</p>
            </div>
            <div class="col-md-4 col-sm-4 border-right border-dark">
                <h5>{{ convertCurrencyToShillings(allSoldValue) }}</h5>
                <p>Sales Value</p>
             </div>
            <div class="col-md-4 col-sm-4 border-right ">
                <h5>{{ convertCurrencyToShillings(allSoldProfit) }}</h5>
                <p>Profits</p>
             </div>
        </div>
        <hr />

                <b-table striped class="text-primary" hover small sticky-header="100vh" :items="items" :fields="fields" sort-icon-left responsive="sm" @row-clicked="handleItemClick" >

            </b-table>
            </div>
            <div v-else>
            <div class="mt-5">
                <div class="text-center text-danger">
                <p class="text-danger">Seems there hasn't been any inventory changes for the period.</p>
                <p class="text-danger">You can filter by dates above!</p>
                </div>
            </div>
            </div>
         </div>
         <div v-else class="card">
            <div class="card-body">
                <div class="text-center">
                    <div class="spinner-border" role="status">

                    </div>
                    <p>Loading...</p>
                </div>
            </div>
        </div>


   </div>


</template>

<script>

    import format from 'date-fns/format'
    import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    export default {
        name: 'InventoryActiviy',
        components: {
            DateRangePicker
        },

        data() {
            return {
                hasLoaded:false,
                allSoldQty:0,
                allSoldValue:0,
                allSoldProfit:0,

                fields: [{
                        key: "item",
                        sortable: true
                    },
                    {
                        key: "activity",
                        sortable: false
                    },
                    {
                        key: "done_by",
                        sortable: true
                    },
                    {
                        key: "date",
                        sortable: true
                    },
                ],
               items:[],
               dateRange: {
                    startDate: null,
                    endDate: null,
                },
                autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,
            }
        },
        watch: {
            dateRange: {
                deep: true,
                handler(after, before) {
                    if (after.startDate && after.endDate) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const startDateString = after.startDate.toISOString().split('T')[0]; // Convert to ISO format without time
                        const endDateString = after.endDate.toISOString().split('T')[0]; // Convert to ISO format without time

                        urlParams.set('start-date', startDateString);
                        urlParams.set('end-date', endDateString);

                        window.history.replaceState(null, null, '?' + urlParams.toString());
                     }


                    this.getInventoryActivity()
                    }
                }
        },
        mounted() {
            this.getInventoryActivity()
        },
        methods: {

            formatDate(date, format) {
                let finaldate = moment(date).format(format);
                return finaldate;
            },
            handleItemClick(item) {
                const url = new URL(window.location.href);
                const searchParams = url.searchParams;

                // Check if the key exists
                if (!searchParams.has('p-identifier-id')) {
                searchParams.set('p-identifier-id', item.product_id); // Add key=value
                url.search = searchParams.toString();


                // Reload the page with the new parameter
                window.location.href = url.toString();
                } else {
                console.log('Key already exists, no reload needed.');
                }
            },

            getInventoryActivity() {
                const urlParams = new URLSearchParams(window.location.search);


                axios.get('/api/inventory-activity',{params:{
                    startdate:  urlParams.get('start-date'),
                    enddate: urlParams.get('end-date'),
                    onlysales: urlParams.get('only-sales'),
                    product_id: (urlParams.has('p-identifier-id')) ? urlParams.get('p-identifier-id') : false
                 }})
                    .then(result => {

                      if(result.data.totalQty)
                      {
                        this.allSoldQty = result.data.totalQty
                        this.allSoldValue = result.data.totalValue
                        this.allSoldProfit = result.data.totalProfit
                        let prodarray = [];
                        $.each(result.data.productMovement, function(key, value) {
                            if (typeof value === 'object') {
                                prodarray.push({
                                    id: value.id,
                                    activity: value.movement_type,
                                    product_id: value.product_id,
                                    done_by:(value.user) ? value.user.name : '',
                                    item:(value.product) ? value.product.product : '',
                                    date:moment(value.created_at).format('HH:mm DD-MM-YYYY'),


                                })
                            }
                        });
                        this.items = prodarray;
                        this.hasLoaded = true
                      }
                      else{
                        let prodarray = [];
                        $.each(result.data, function(key, value) {
                            if (typeof value === 'object') {
                                prodarray.push({
                                    id: value.id,
                                    activity: value.movement_type,
                                    product_id: value.product_id,
                                    done_by:(value.user) ? value.user.name : '',
                                    item:(value.product) ? value.product.product : '',
                                    date:moment(value.created_at).format('HH:mm DD-MM-YYYY'),


                                })
                            }
                        });
                        this.items = prodarray;
                        this.hasLoaded = true
                      }



                    });
            }

        }
    }
</script>


